<flw-edit
  (previousState)="previousState()"
  (save)="save()"
  [editForm]="editForm"
  [formGroup]="editForm"
  [isSaving]="isSaving"
  [pageName]="pageName"
  [record]="record"
>
  <div page-content>
    <div class="row">
      <div class="col">
        <label class="form-control-label" jhiTranslate="app.programEdition.programEnum">Program Enum</label>
        <p-dropdown [options]="ProgramEnumOptions" [autoDisplayFirst]="false" formControlName="programEnum">
          <ng-template pTemplate="selectedItem">
            <span>{{ 'app.ProgramEnum.' + editForm.get(['programEnum'])!.value | translate }}</span>
          </ng-template>
          <ng-template let-item pTemplate="item">
            <span>{{ 'app.ProgramEnum.' + item | translate }}</span>
          </ng-template>
        </p-dropdown>
      </div>
      <div
        *ngIf="
          editForm.get('programEnum')!.value === ProgramEnum.OTL ||
          editForm.get('programEnum')!.value === ProgramEnum.CUIDA_TE ||
          editForm.get('programEnum')!.value === ProgramEnum.CUIDA_TE2
        "
        class="col"
      >
        <label class="form-control-label" jhiTranslate="app.programEdition.programModality">Program Modality</label>
        <p-dropdown
          *ngIf="editForm.get('programEnum')!.value === ProgramEnum.OTL"
          [options]="ProgramModalityOtlOptions"
          [autoDisplayFirst]="false"
          formControlName="programModality"
        >
          <ng-template pTemplate="selectedItem">
            <span>{{ 'app.ProgramModality.' + editForm.get(['prog#ramModality'])!.value | translate }}</span>
          </ng-template>
          <ng-template let-item pTemplate="item">
            <span>{{ 'app.ProgramModality.' + item | translate }}</span>
          </ng-template>
        </p-dropdown>
        <p-dropdown
          *ngIf="editForm.get('programEnum')!.value === ProgramEnum.CUIDA_TE"
          [options]="ProgramModalityCuidateOptions"
          [autoDisplayFirst]="false"
          formControlName="programModality"
        >
          <ng-template pTemplate="selectedItem">
            <span>{{ 'app.ProgramModality.' + editForm.get(['programModality'])!.value | translate }}</span>
          </ng-template>
          <ng-template let-item pTemplate="item">
            <span>{{ 'app.ProgramModality.' + item | translate }}</span>
          </ng-template>
        </p-dropdown>
        <p-dropdown
          *ngIf="editForm.get('programEnum')!.value === ProgramEnum.CUIDA_TE2"
          [options]="ProgramModalityCuidate2Options"
          [autoDisplayFirst]="false"
          formControlName="programModality"
        >
          <ng-template pTemplate="selectedItem">
            <span>{{ 'app.ProgramModality.' + editForm.get(['programModality'])!.value | translate }}</span>
          </ng-template>
          <ng-template let-item pTemplate="item">
            <span>{{ 'app.ProgramModality.' + item | translate }}</span>
          </ng-template>
        </p-dropdown>
      </div>
      <div class="form-group col col-lg-2">
        <div class="form-group col-sm">
          <label class="form-control-label" for="field_position" jhiTranslate="app.programNews.position">Position</label>
          <input class="form-control" formControlName="position" id="field_position" name="position" type="number" />
        </div>
      </div>
      <div class="form-group col col-lg-2">
        <label class="form-control-label" for="field_active" jhiTranslate="app.programGeneralInformation.active">Active</label>
        <div class="custom-control custom-checkbox mb-3">
          <input class="custom-control-input" formControlName="active" id="field_active" name="active" type="checkbox" />
          <label class="custom-control-label" for="field_active">
            <span jhiTranslate="app.programGeneralInformation.active">Active</span>
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="form-group col col-lg-6">
        <label class="form-control-label" for="field_titlePT" jhiTranslate="app.programNews.titlePT">Title PT</label>
        <input class="form-control" formControlName="titlePT" id="field_titlePT" name="titlePT" type="text" />
      </div>
      <div class="form-group col col-lg-6">
        <label class="form-control-label" for="field_titleEN" jhiTranslate="app.programNews.titleEN">Title EN</label>
        <input class="form-control" formControlName="titleEN" id="field_titleEN" name="titleEN" type="text" />
      </div>
    </div>
    <div class="row">
      <div class="form-group col col-lg-6">
        <label class="form-control-label" for="field_descriptionPT" jhiTranslate="app.programNews.descriptionPT">Description PT</label>
        <p-editor
          [className]="'toolbar-hidden'"
          [style]="{ height: '100px' }"
          formControlName="descriptionPT"
          id="field_descriptionPT"
          tabindex="1"
        >
          <p-header> </p-header>
        </p-editor>
      </div>
      <div class="form-group col col-lg-6">
        <label class="form-control-label" for="field_descriptionEN" jhiTranslate="app.programNews.descriptionEN">Description EN</label>
        <p-editor
          [className]="'toolbar-hidden'"
          [style]="{ height: '100px' }"
          formControlName="descriptionEN"
          id="field_descriptionEN"
          tabindex="1"
        >
          <p-header> </p-header>
        </p-editor>
      </div>
    </div>
    <div class="row">
      <div class="form-group col col-lg-3">
        <label class="form-control-label" for="field_startDate" jhiTranslate="app.programNews.startDate">Start Date</label>
        <p-calendar
          [appendTo]="'body'"
          [dateFormat]="DATE_FORMAT_PRIME"
          [showButtonBar]="true"
          [showIcon]="true"
          [showTime]="true"
          formControlName="startDate"
          id="field_startDate"
          name="startDate"
        ></p-calendar>
      </div>
      <div class="form-group col col-lg-3">
        <label class="form-control-label" for="field_endDate" jhiTranslate="app.programNews.endDate">End Date</label>
        <p-calendar
          [appendTo]="'body'"
          [dateFormat]="DATE_FORMAT_PRIME"
          [showButtonBar]="true"
          [showIcon]="true"
          [showTime]="true"
          formControlName="endDate"
          id="field_endDate"
          name="endDate"
        ></p-calendar>
      </div>
      <div class="form-group col col-lg-3">
        <label class="form-control-label" for="field_editedDate" jhiTranslate="app.programNews.editedDate">Edited Date</label>
        <p-calendar
          [appendTo]="'body'"
          [dateFormat]="DATE_FORMAT_PRIME"
          [showButtonBar]="true"
          [showIcon]="true"
          [showTime]="true"
          formControlName="editedDate"
          id="field_editedDate"
          name="editedDate"
        ></p-calendar>
      </div>
    </div>
    <div class="row">
      <div class="form-group col">
        <label class="form-control-label" for="field_image" jhiTranslate="app.programNews.image">Image</label>
        <div>
          <div *ngIf="editForm.get('image')!.value" class="form-text text-danger clearfix">
            <a
              (click)="openFile(editForm.get('imageContentType')!.value, editForm.get('image')!.value)"
              class="pull-left"
              jhiTranslate="entity.action.open"
              >open</a
            >
            <br />
            <span class="pull-left">{{ editForm.get('imageContentType')!.value }}, {{ byteSize(editForm.get('image')!.value) }}</span>
            <button
              (click)="editForm.patchValue({ image: null }); editForm.patchValue({ imageContentType: null })"
              class="btn btn-secondary btn-xs pull-right"
              type="button"
            >
              <fa-icon [icon]="'times'"></fa-icon>
            </button>
          </div>
          <input (change)="setFileData($event, 'image', false)" id="file_image" jhiTranslate="entity.action.addblob" type="file" />
        </div>
        <input class="form-control" formControlName="image" id="field_image" name="image" type="hidden" />
        <input class="form-control" formControlName="imageContentType" id="field_imageContentType" name="imageContentType" type="hidden" />
      </div>
      <div class="form-group col">
        <div class="form-group col-sm">
          <label class="form-control-label" for="field_imageSmall" jhiTranslate="app.programNews.imageSmall">Image Small</label>
          <div>
            <div *ngIf="editForm.get('imageSmall')!.value" class="form-text text-danger clearfix">
              <a
                (click)="openFile(editForm.get('imageSmallContentType')!.value, editForm.get('imageSmall')!.value)"
                class="pull-left"
                jhiTranslate="entity.action.open"
                >open</a
              >
              <br />
              <span class="pull-left"
                >{{ editForm.get('imageSmallContentType')!.value }}, {{ byteSize(editForm.get('imageSmall')!.value) }}</span
              >
              <button
                (click)="editForm.patchValue({ imageSmall: null }); editForm.patchValue({ imageSmallContentType: null })"
                class="btn btn-secondary btn-xs pull-right"
                type="button"
              >
                <fa-icon [icon]="'times'"></fa-icon>
              </button>
            </div>
            <input
              (change)="setFileData($event, 'imageSmall', false)"
              id="file_imageSmall"
              jhiTranslate="entity.action.addblob"
              type="file"
            />
          </div>
          <input class="form-control" formControlName="imageSmall" id="field_imageSmall" name="imageSmall" type="hidden" />
          <input
            class="form-control"
            formControlName="imageSmallContentType"
            id="field_imageSmallContentType"
            name="imageSmallContentType"
            type="hidden"
          />
        </div>
      </div>
    </div>
  </div>
</flw-edit>
